module.exports = __webpack_public_path__ + "img/tablero-gestion.6397df21.png";